import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { GoBackButtonWithTitle, PageWrapper, Spinner } from 'components';

import { Vision } from '../../components';
import { TargetsList } from '../TargetsList';
import { ContentW, PageTitle } from './styled';
import { useKpiFullPageDetails } from './useKpiFullPageDetails';

export function KpiPage(): ReactElement {
  const { t } = useTranslation();
  const { isLoading, vision, activeTargets, completedTargets } = useKpiFullPageDetails();

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <PageWrapper>
      <GoBackButtonWithTitle
        title={t('common.back')}
        containerSx={{
          marginTop: 0,
          maxWidth: '100%',
          marginBottom: '16px',
        }}
      />
      <PageTitle>{t('kpi.fullPage.activeKPI')}</PageTitle>
      <ContentW>
        <Vision vision={vision} />
        <TargetsList list={activeTargets} title={t('kpi.fullPage.activeKPI')} isActiveList />{' '}
        {completedTargets.length > 0 && (
          <TargetsList list={completedTargets} title={t('kpi.fullPage.completedKPI')} />
        )}
      </ContentW>
    </PageWrapper>
  );
}
